import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const GET_VERANSTALTUNG_INFO_KATEGORIEN2 = '[VeranstaltungenModul] GetVeranstaltungInfoKategorien2 laden';
export const GET_VERANSTALTUNG_INFO_KATEGORIEN2_AUSFUEHREN = '[VeranstaltungenModul] GetVeranstaltungInfoKategorien2 ausführen';
export const GET_VERANSTALTUNG_INFO_KATEGORIEN2_ERFOLGREICH = '[VeranstaltungenModul] GetVeranstaltungInfoKategorien2 laden erfolgreich';
export const GET_VERANSTALTUNG_INFO_KATEGORIEN2_FEHLER = '[VeranstaltungenModul] GetVeranstaltungInfoKategorien2 Ladefehler';
export const GET_VERANSTALTUNG_INFO_KATEGORIEN2_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] GetVeranstaltungInfoKategorien2 nicht ausgeführt (evtl. Offline)';


export class GetVeranstaltungInfoKategorien2Action implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIEN2;
        constructor( public veranstaltung_id:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungInfoKategorien2AusfuehrenAction implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIEN2_AUSFUEHREN;
        constructor( public veranstaltung_id:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungInfoKategorien2ErfolgreichAction implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIEN2_ERFOLGREICH;
        constructor(public payload: Array<api.InfoKategorie>,  public veranstaltung_id:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungInfoKategorien2FehlerAction implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIEN2_FEHLER;
        constructor(public payload: any,  public veranstaltung_id:string , public optPayload: any = null) {}
    }
export class GetVeranstaltungInfoKategorien2NichtAusgefuehrtAction implements Action {
    readonly type = GET_VERANSTALTUNG_INFO_KATEGORIEN2_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenQueryVeranstaltungInfoKategorien2Actions =
    GetVeranstaltungInfoKategorien2Action
    | GetVeranstaltungInfoKategorien2AusfuehrenAction
    | GetVeranstaltungInfoKategorien2ErfolgreichAction
    | GetVeranstaltungInfoKategorien2FehlerAction
    | GetVeranstaltungInfoKategorien2NichtAusgefuehrtAction
    ;
